// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { Configuration, PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { CREHANA_BASE_URL_PRD } from '@crehana/constants';
import FacebookLogo from '@crehana/icons/FacebookLogo';
import GoogleIcon from '@crehana/icons/GoogleIcon';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Tooltip } from '@crehana/ui';

import LoadingOverlay from '../components/LoadingOverlay';
import MicrosoftButton from '../components/MicrosoftButton';

const configuration: Configuration = {
  auth: {
    clientId: '2660be26-2a13-4cec-82c3-337ab10852b0',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: '/home/',
  },
};

const pca = new PublicClientApplication(configuration);

type SocialButtonsVariantMinimalV3Props = {
  shouldRenderFacebookButton: boolean;
  facebookButtonProps: {
    onClick: () => void;
  };
  gmailButtonProps: {
    id: string;
    ref: React.RefObject<HTMLButtonElement>;
  };
  processingSocialAuth: boolean;
  loadingFacebookAndGoogleScripts: boolean;
  currentForm?: string;
  hideFBAuthButton?: boolean;
  hideFBAuthLink?: boolean;
  showMicrosoftButton?: boolean;
  nextUrl?: string;
  facebookLabel: string;
  googleLabel: string;
};
const SocialButtonsVariantMinimalV3: React.FC<
  React.PropsWithChildren<SocialButtonsVariantMinimalV3Props>
> = ({
  shouldRenderFacebookButton,
  facebookButtonProps,
  gmailButtonProps,
  processingSocialAuth,
  loadingFacebookAndGoogleScripts,
  hideFBAuthButton,
  hideFBAuthLink,
  showMicrosoftButton,
  nextUrl,
  facebookLabel,
  googleLabel,
}) => {
  const renderFBAuth = () => {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (hideFBAuthButton && hideFBAuthLink) return null;
    if (hideFBAuthButton && !hideFBAuthLink) {
      return (
        <Tooltip label={facebookLabel} position="bottom" type="regular">
          <a
            className="flex items-center justify-center w-56 h-48 mr-20 bg-white rounded-5 shadow-4-dp"
            href={`${CREHANA_BASE_URL_PRD}/login/facebook/?next=${nextUrl}`}
            {...facebookButtonProps}
          >
            <FacebookLogo size={28} className="tw-text-neutral-light-100" />
          </a>
        </Tooltip>
      );
    }
    return (
      <Tooltip label={facebookLabel} position="bottom" type="regular">
        <button
          className="flex items-center justify-center w-56 h-48 mr-20 bg-white rounded-5 shadow-4-dp"
          type="button"
          {...facebookButtonProps}
        >
          <FacebookLogo size={28} />
        </button>
      </Tooltip>
    );
  };

  return (
    <div className="flex w-full">
      <div className="flex items-center justify-center m-auto max-w-280">
        {shouldRenderFacebookButton && renderFBAuth()}
        <Tooltip label={googleLabel} position="bottom" type="regular">
          <button
            className="flex items-center justify-center w-56 h-48 bg-white rounded-5 shadow-4-dp"
            type="button"
            style={{
              display: window.navigator.userAgent
                .toLowerCase()
                .includes('instagram')
                ? 'none !important'
                : 'flex',
            }}
            {...gmailButtonProps}
          >
            <GoogleIcon size={28} className="tw-text-neutral-light-100" />
          </button>
        </Tooltip>
      </div>
      {showMicrosoftButton && (
        <MsalProvider instance={pca}>
          <div className="pl-16">
            <MicrosoftButton />
          </div>
        </MsalProvider>
      )}
      {(processingSocialAuth || loadingFacebookAndGoogleScripts) && (
        <LoadingOverlay />
      )}
    </div>
  );
};

export default SocialButtonsVariantMinimalV3;
